module.exports = __webpack_public_path__ + "assets/img/bgok.e6528e10.png";